import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const DropdownWrapperLarge = styled.div`
  width: ${rem(300)};
`;

export const DropdownWrapperMedium = styled.div`
  width: ${rem(190)};
`;

export const DropdownWrapperSmall = styled.div`
  width: ${rem(135)};
`;

export const InputWrapperLarge = styled.div`
  width: ${rem(300)};
`;

export const InputWrapperMedium = styled.div`
  width: ${rem(190)};
`;

export const InputWrapperSmall = styled.div`
  width: ${rem(135)};
`;